import { createSlice } from '@reduxjs/toolkit';

// types
import { SectionSliceProps } from 'types/section';

const initialState: SectionSliceProps = {
    sectionName: '',
    ignoreDrawer: false
};

// ==============================|| SLICE - SECTION ||============================== //

const section = createSlice({
    name: 'section',
    initialState,
    reducers: {
        updateSectionName(state, action) {
            const { sectionName } = action.payload;

            state.sectionName = sectionName;
        },
        toggleIgnoreDrawer(state) {
            state.ignoreDrawer = !state.ignoreDrawer;
        }
    }
});

export default section.reducer;

export const { updateSectionName, toggleIgnoreDrawer } = section.actions;
